module.exports = __webpack_public_path__ + "media/get_income.5e9374f8.mp4";